<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-info">
          <form @submit.prevent class="form-horizontal">
            <div class="box-body">
              <div class="row">
                <div class="col-md-2">
                  <div class="q_avatar" @mouseover="showImageControl(true)" @mouseleave="showImageControl(false)">
                    <img :src="formData.imageUrl == '' ? (formData.picture ? formData.picture : '/static/img/placeholder.png') : '/image/Company/' + formData.imageUrl + '?' + Date.now()" class="img img-responsive" border="1" ref="companyImage">
                    <div class="q_form_image_controls" ref="imageControl">
                      <span class="icon ion-pencil pull-left q_select_file_button" title="Edit" @click="$refs.filePicture.click()"></span>
                      <span class="icon ion-ios-trash-o pull-right q_clear_file_button" title="Clear" @click="clearPicture()"></span>               
                      <div class="q_hidden_input_file ">
                        <input type="file" accept="image/*" ref="filePicture" @change="pictureChange">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-5">                    
                  <div class="form-group">
                    <label for="inputName">Name</label>
                    <h1 style="margin-top:0px;">
                      <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Company Name" v-model="formData.name">
                    </h1>                        
                  </div>                                          
                </div>                    
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General Info</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_PROJECT }"><a @click="onClickTabProject()" href="#tab_2" data-toggle="tab" aria-expanded="true">Projects</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                      <div class="box no-border">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputEmail" class="col-sm-4 control-label">Email</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputEmail" placeholder="" v-model="formData.email">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputAddress1" class="col-sm-4 control-label">Address 1</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputAddress1" placeholder="" v-model="formData.address1">
                              </div>                     
                            </div>                                                 
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCurrency" class="col-sm-4 control-label">Currency</label>
                              <div class="col-sm-8">
                                <select v-model="formData.currencyId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                  <option v-for="(row, i) in listCurrency" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputAddress2" class="col-sm-4 control-label">Address 2</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputAddress2" placeholder="" v-model="formData.address2">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputReportHeader" class="col-sm-4 control-label">Report Header</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputReportHeader" placeholder="" v-model="formData.reportHeader">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputReportFooter" class="col-sm-4 control-label">Report Footer</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputReportFooter" placeholder="" v-model="formData.reportFooter">
                              </div>                     
                            </div>                                                  
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputSAPCode" class="col-sm-4 control-label">SAP Code</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputSAPCode" placeholder="" v-model="formData.sapCode">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                          </div>
                        </div>                                                  
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_PROJECT }" class="tab-pane" id="tab_2">
                      <div class="box no-border">                             
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:10px;text-align:right">#</th>
                                <th style="text-align:left;">Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listProject" v-bind:key="i">
                                <td style="text-align:right;">{{ startSequence + i + 1}}</td>
                                <td style="text-align:left;">{{ row.name }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>                        
                  </div>
                </div>
              </div>                                                                     
              <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
              <input type="hidden" class="form-control" id="inputProductTypeId" v-model="formData.currencyId">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <button v-if="viewMode != MODE_VIEW" @click="onCancel()" class="btn btn-warning">Cancel</button>
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div> 
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'

const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_PROJECT = 'tabProject'

export default {
  name: 'CompanyForm',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_PROJECT: TAB_PROJECT,
      formData: {
        id: 0,
        name: '',
        email: '',
        phone: '',
        currencyName: '',
        currencyId: 0,
        reportHeader: '',
        reportFooter: '',
        imageUrl: '',
        picture: null,
        address1: '',
        address2: '',
        sapCode: ''
      },
      startSequence: 0,
      tabActive: '',
      listProject: null,
      listCurrency: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.callbackId ? this.$route.params.callbackId : this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback

    this.tabActive = TAB_GENERAL
    this.getDetail()
    this.getCurrency()
  },
  mounted() {
  },
  methods: {
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function() {
        var reader = new FileReader()
        reader.onloadend = function() {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    },
    getDetail() {
      var me = this
      if (this.formData.id !== 0) {
        api
          .request('Account', 'get', '/api/Company/GetDetail?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data
            this.formData = data.entity
          })
          .then(response => {
            this.getCurrency()
          })
          .then(response => {
            this.toDataURL(me.$refs.companyImage.src, function(dataUrl) {
              me.formData.picture = dataUrl
              me.formData.imageUrl = ''
            })
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    showImageControl(show) {
      if (this.viewMode === MODE_VIEW) {
        return
      }
      let el = this.$refs.imageControl
      el.style.opacity = show ? 0.8 : 0
    },
    pictureChange(e) {
      const image = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.formData.picture = e.target.result
        this.$refs.companyImage.src = e.target.result
      }
    },
    clearPicture() {
      this.formData.picture = null
      this.formData.imageUrl = ''
    },
    getCurrency() {
      api
        .request('Account', 'get', '/api/Currency/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.email = ''
      this.formData.currencyId = 0
      this.formData.currencyName = ''
      this.formData.reportHeader = ''
      this.formData.reportFooter = ''
      this.formData.imageUrl = ''
      this.formData.picture = null
      this.formData.address1 = ''
      this.formData.address2 = ''
      this.formData.sapCode = ''
      this.getCurrency()
    },
    onDisplay() {
      this.viewMode = MODE_VIEW
      this.getDetail()
    },
    onEdit(formData) {
      if (!utilities.IsObjectAuthorized('Company', 'Activity', 'Edit')) {
        return
      }
      this.viewMode = MODE_UPDATE
      this.getDetail()
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.$router.push({ name: this.callback })
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        Email: this.formData.email,
        CurrencyId: this.formData.currencyId,
        ReportHeader: this.formData.reportHeader,
        ReportFooter: this.formData.reportFooter,
        ImageBase64String: this.formData.picture,
        Address1: this.formData.address1,
        Address2: this.formData.address2,
        SAPCode: this.formData.sapCode
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Account', 'post', '/api/Company/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    // delete(data) {
    //   var status = ''
    //   var message = ''
    //   var reqData = {
    //     Id: data.id,
    //     Name: data.name
    //   }
    //   api.request('Account', 'post', '/api/Company/Delete', reqData)
    //     .then(response => {
    //       var resData = response.data
    //       status = resData.returnStatus ? 'success' : 'error'
    //       message = resData.returnMessage
    //       this.inquiry()
    //     })
    //     .catch(error => {
    //       status = 'error'
    //       message = 'Error happens when call API delete: ' + error.message
    //     })
    //   return { status: status, message: message }
    // },
    onClickTabProject () {
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=CompanyId = ' + this.formData.id +
                                 '&PageSize=999' + '&CurrentPageNumber=1' + '&SortDirection=ASC' + '&SortExpression=Name', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// CompanyForm.vue?a23908a0